import ModalBackdropTemplate from 'text!../templates/modal-backdrop-template.html';

export default ['$modalStack', '$timeout', function ($modalStack, $timeout) {
    return {
        restrict: 'EA',
        replace: true,
        template: ModalBackdropTemplate,
        link: function link(scope) {
            scope.animate = false;

            // trigger CSS transitions
            $timeout(function () {
                scope.animate = true;
            });

            scope.close = function (evt) {
                var modal = $modalStack.getTop();
                if (modal && modal.value.backdrop && modal.value.backdrop !== 'static') {
                    evt.preventDefault();
                    evt.stopPropagation();
                    $modalStack.dismiss(modal.key, 'backdrop click');
                }
            };
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/modal/directives/ModalBackdrop.js
// module id = 1132
// module chunks = 0